export default {

    // NOTE: If grid is defined with checkboxes, you can set the groupedCheckboxes option for checkboxes
    // in the category headers.  Code for this is in DFGridCheckbox.

    _configGrouping: function(options, element) {
        /**
         * Per Kendo recommendation, need to listen for a click event on the grid,
         * in order to process click events on the group header.
         */
        element.on("click", ".groupHeaderName", $.proxy(this._onGroupHeaderNameClick, this));
        this.collapsedGroups = [];
    },

    /**
     * Clicking on the grouping name in the groupHeaderTemplate should expand the group.
     * The grouping name should be defined by a "groupHeaderName" class in the groupHeaderTemplate.
     * The Kendo grid does not have a toggle property, or a way of checking expanded state beyond the
     * .k-i-expand and .k-i-collapse classes.
     */
    _onGroupHeaderNameClick: function(evt) {
        var isCollapsed = $(evt.currentTarget).closest("p.k-reset").find("a.k-icon").hasClass("k-svg-i-caret-alt-right"),
            row = $(evt.currentTarget).closest("tr");
        if (isCollapsed) {
            this.expandGroup(row);
        } else {
            this.collapseGroup(row);
        }
    },

    /**
     * Track collapsed groups, but don't auto collapse / expand.  Leave this to the
     * viewmodel to know when to do, since the use cases could vary.
     *
     * The grouping must be set on the dataSource in order to use this functionality.
     **/
    collapsedGroups: [],

    /**
     * Override existing method, to keep track of currently expanded items.
     *
     * The grouping must be set on the dataSource in order to use this functionality.
     **/
    collapseGroup: function(row) {
        this._cancelEditOnCollapse(row);
        kendo.ui.Grid.fn.collapseGroup.apply(this, arguments);

        var item = this.dataItem(row);
        if (item) {
            var groupingField = this.dataSource.group()[0].field,
                itemId = item[groupingField];
            if (this.collapsedGroups.indexOf(itemId) == -1) {
                this.collapsedGroups.push(itemId);
            }
        }
    },

    /**
     * Override existing method, to keep track of currently expanded items.
     *
     * The grouping must be set on the dataSource in order to use this functionality.
     **/
    expandGroup: function(row) {
        kendo.ui.Grid.fn.expandGroup.apply(this, arguments);

        var item = this.dataItem(row);
        if (item) {
            var groupingField = this.dataSource.group()[0].field,
                itemId = item[groupingField],
                arrIndex = this.collapsedGroups.indexOf(itemId);
            if (arrIndex != -1) {
                this.collapsedGroups.splice(arrIndex, 1);
            }
        }
    },

    /**
     * Collapse all groups held in the collapsedGroups array.  Should keep
     * last state of which groupings were collapsed and expanded.
     *
     * The grouping must be set on the dataSource in order to use this functionality.
     **/
    keepCollapsedGroups: function() {
        this.tbody.find(".k-grouping-row").toArray()
            .map((row) => {
                return {
                    row: row,
                    item: this.dataItem(row)
                };
            })
            .filter(function(row) {
                return !!row.item;
            })
            .filter((row) => {
                const groupingField = this.dataSource.group()[0].field;
                const itemId = row.item[groupingField];
                return this.collapsedGroups.indexOf(itemId) !== -1;
            })
            .forEach((row) => {
                this.collapseGroup(row.row);
            });
    },

    /**
     * Collapse all groups, for a grid with grouped data.
     */
    collapseAllGroups: function() {
        var me = this;
        me.tbody.find(".k-grouping-row").each(function(index, row) {
            me.collapseGroup(row);
        });
    }

};
